import { translate } from '@utils/i18n';
import { ActionCell } from './components/ActionCell';
import { BuildingCell } from './components/BuildingCell';
import { InstallationYearCell } from './components/InstallationYearCell';
import { IntervalCell } from './components/IntervalCell';
import { LocationCell } from './components/LocationCell';
import { StatusCell } from './components/StatusCell';
export const NAMESPACE = 'analytic_reports.sprinkler_projection_report';
export const PAGE_SIZE = 25;
export const NON_HIDEABLE_COLUMN_KEYS = ['building', 'status', 'actions'];
export const COLUMNS = [
    {
        dataKey: 'building',
        label: translate('columns.building', { namespace: NAMESPACE }),
        columnType: 'primary',
        renderer: BuildingCell
    },
    { dataKey: 'territory', label: translate('columns.territory', { namespace: NAMESPACE }) },
    { dataKey: 'system', label: translate('columns.system', { namespace: NAMESPACE }) },
    { dataKey: 'group', label: translate('columns.group', { namespace: NAMESPACE }) },
    { dataKey: 'location', label: translate('columns.location', { namespace: NAMESPACE }), renderer: LocationCell },
    {
        dataKey: 'installationDate',
        label: translate('columns.installation_date', { namespace: NAMESPACE }),
        renderer: InstallationYearCell
    },
    { dataKey: 'interval', label: translate('columns.interval', { namespace: NAMESPACE }), renderer: IntervalCell },
    { dataKey: 'nfpaEdition', label: translate('columns.nfpa_edition', { namespace: NAMESPACE }) },
    { dataKey: 'nextServiceDate', label: translate('columns.next_service_date', { namespace: NAMESPACE }) },
    { dataKey: 'notes', label: translate('columns.notes', { namespace: NAMESPACE }) },
    {
        dataKey: 'status',
        label: translate('columns.status', { namespace: NAMESPACE }),
        renderer: StatusCell
    },
    { dataKey: 'actions', label: '', columnType: 'last', renderer: ActionCell }
];
